import React from 'react';
import { cn } from '../../lib/cn';

export interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  eyebrow,
  title,
  subtitle,
  actions,
  className,
}) => (
  <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
    <div>
      {eyebrow && (
        <p className="text-xs uppercase tracking-[0.2em] text-muted">{eyebrow}</p>
      )}
      <h2 className="mt-1 text-2xl font-semibold text-text">{title}</h2>
      {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
    </div>
    {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
  </div>
);
